import { IconCaretDownFill, IconCaretUpFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import classnames from 'classnames';
import React, { FC, useCallback, useRef } from 'react';

import { actions } from '../../../ducks/diffUi';
import { RectFragFragment } from '../../../graphql/__generated__/graphql';
import { useVisualDispatch } from '../../../reduxHooks';
import { ChangeIndicatorButton } from './ChangeIndicatorButton';

const TYPOGRAPHY_CLASSES = 'py-0.5 px-1 font-semibold';

export const ChangeIndicator: FC<ChangeIndicatorProps> = (props) => {
  const { clusters, hasBaseline } = props;
  const currentIndex = useRef(-1);
  const dispatch = useVisualDispatch();

  const goToNext = useCallback(() => {
    currentIndex.current = (
      currentIndex.current + 1 > clusters.length - 1
    ) ? 0 : currentIndex.current + 1;
    dispatch(actions.scrollToDiff(clusters[currentIndex.current]));
  }, [clusters, dispatch]);

  const goToPrev = useCallback(() => {
    currentIndex.current = (
      currentIndex.current - 1 < 0
    ) ? clusters.length - 1 : currentIndex.current - 1;
    dispatch(actions.scrollToDiff(clusters[currentIndex.current]));
  }, [clusters, dispatch]);

  let label = (
    <Typography
      className={classnames(TYPOGRAPHY_CLASSES, 'text-orange-600')}
      variant="body"
    >
      New
    </Typography>
  );

  if (clusters.length > 0) {
    label = (
      <>
        <Typography
          className={classnames(TYPOGRAPHY_CLASSES, 'text-red-600')}
          variant="body"
        >
          {clusters.length}
          {' '}
          changes
        </Typography>
        <ChangeIndicatorButton
          aria-label="Next change"
          icon={IconCaretDownFill}
          onPress={goToNext}
        />
        <ChangeIndicatorButton
          aria-label="Previous change"
          className="rounded-tr rounded-br"
          icon={IconCaretUpFill}
          onPress={goToPrev}
        />
      </>
    );
  } else if (hasBaseline) {
    label = (
      <Typography
        className={classnames(TYPOGRAPHY_CLASSES, 'text-green-600')}
        variant="body"
      >
        No changes detected
      </Typography>
    );
  }

  return (
    <div className="bg-gray-50 rounded flex flex-row flex-nowrap whitespace-nowrap">
      {label}
    </div>
  );
};

export interface ChangeIndicatorProps {
  clusters: RectFragFragment[];
  hasBaseline: boolean;
}
